import { useSelector } from 'react-redux';
import { parse } from 'query-string';

/**
 * When account flow is a part of a regular question flow, this hook will restore the flow to the correct location
 * by checking the history state `from` property (it means that the flow was redirected from a regular question flow)
 * or by checking the `redirectAfterComplete` search param (it was made to fix back navigation from the question flow
 * @param location
 * @return {undefined|string} return undefined if no redirect is needed, otherwise return the redirect location
 */
export const useFlowRestoration = location => {
  const redirectHistory = useSelector(({ navigation }) => navigation.redirectHistory);

  const redirectHistoryList = Object.entries(redirectHistory);

  const parsedSearchParams = parse(location.search);

  const locationToCheck = location.state?.from || parsedSearchParams.redirectAfterComplete;

  const currentRedirectState = redirectHistoryList.find(item => item.includes(locationToCheck));

  if (currentRedirectState?.length) {
    return currentRedirectState.find(item => item !== locationToCheck);
  }
};
